module.exports = __webpack_public_path__ + "static/media/5a36954d40bea2.0735336615135266052652.b4dd4c5e.png";